/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {FloatingComponent} from "../floating/floating.component";

/**
 * todo
 */
@Component({
	selector: "aigia-ballistic-chart",
	templateUrl: "./ballistic-chart.component.html",
	styleUrls: ["../floating/floating.component.css", "./ballistic-chart.component.css"],
})
export class BallisticChartComponent extends FloatingComponent implements OnChanges, OnInit {

	@Input() public locked: boolean;
	@Input() public size: number[];
	@Input() public shots: any[];
	@Input() public name: string;

	public modename: string;
	public modestyle: any;

	public title: string = "Ballistic Chart";

	public progress = false;

	public dataSource: any[] = [];

	// options
	public animations: boolean = true;
	public xAxisLabel: string = "";
	public yAxisLabel: string = "";

	public yScaleMax: number;
	public yScaleMin: number;

	public autoScale: boolean;

	@Output() public progrssChange = new EventEmitter<boolean>();

	public colorScheme = {
		domain: ["#1CBCD8", "#FF8D60", "#FF586B", "#5c6bc0", "#3d5afe", "#4caf50", "#673ab7"],
	};

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {

		Object.keys(changes).forEach((propName) => {
			switch (propName) {
				case "visible":
				case "shots":
					if (this.visible) {
						this.draw(this.shots);
					}
					break;
				default:
					break;
			}
		});
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.yAxisLabel = this.nameToUnit(this.name);
		this.modename = "light";
		this.modestyle = {fill: "#000000"};
	}

	/**
	 * @returns none
	 */
	public initLayout(): void {
	}

	/**
	 * todo
	 */
	public xAxisFormat(value: string): string {
		return value.substr(11, 5);
	}

	/**
	 * @returns none
	 */
	public changeName(): void {
		this.yAxisLabel = this.nameToUnit(this.name);
		this.draw(this.shots);
	}

	/**
	 * todo
	 */
	public nameToUnit(name: string): string {
		let result: string = "";
		switch (name) {
			case "ミート率":
				result = "";
				break;
			case "トータル":
				result = "Yard";
				break;
			case "キャリー":
				result = "Yard";
				break;
			case "ヘッドスピード":
				result = "m/s";
				break;
			case "ボール初速":
				result = "m/s";
				break;
			case "バックスピン":
				result = "rpm";
				break;
			case "サイドスピン":
				result = "rpm";
				break;
			case "打ち出し角":
				result = "度";
				break;
			case "ブロー角":
				result = "度";
				break;
			case "ヘッド軌道":
				result = "度";
				break;
			case "フェイス角":
				result = "度";
				break;
			default:
		}
		return result;
	}

	/**
	 * @returns none
	 *
	 * unit=""
	 * unit="Yard"
	 * unit="m/s"
	 * unit="rpm"
	 * unit="度"
	 */
	public draw(shots: any): void {
		this.Progress(true);
		try {
			if (shots) {
				const dataSource: any[] = [];
				shots.forEach((shot: any) => {
					if (shot.prizm) {
						const datalist = shot.prizm.DataList;
						const name = shot.name;
						datalist.forEach((data: any): void => {
								dataSource.push({name: "", series: []});
								const unit = this.nameToUnit(data.Name);
								const value = data.Value;
								switch (data.Name) {
									case "トータル":// Yard
										if (this.name === "トータル") {
											this.autoScale = true;
											dataSource[0].name = data.Name;
											dataSource[0].series.push({name: name, value: value});
										}
										break;
									case "トータルブレ":// "Yard"
										if (this.name === "トータルブレ") {
											this.autoScale = true;
											dataSource[1].name = data.Name;
											dataSource[1].series.push({name: name, value: value});
										}
										break;
									case "キャリー":// "Yard"
										if (this.name === "キャリー") {
											this.autoScale = true;
											dataSource[2].name = data.Name;
											dataSource[2].series.push({name: name, value: value});
										}
										break;
									case "キャリーブレ":// "Yard"
										if (this.name === "キャリーブレ") {
											this.autoScale = true;
											dataSource[3].name = data.Name;
											dataSource[3].series.push({name: name, value: value});
										}
										break;
									case "ヘッドスピード":// "m/s"
										if (this.name === "ヘッドスピード") {
											this.yScaleMax = 0;
											this.yScaleMin = 60;
											this.autoScale = false;
											dataSource[4].name = data.Name;
											dataSource[4].series.push({name: name, value: value});
										}
										break;
									case "ボール初速":// "m/s"
										if (this.name === "ボール初速") {
											this.yScaleMax = 60;
											this.yScaleMin = 0;
											this.autoScale = false;
											dataSource[5].name = data.Name;
											dataSource[5].series.push({name: name, value: value});
										}
										break;
									case "ミート率": // ""
										if (this.name === "ミート率") {
											this.yScaleMax = 1.00;
											this.yScaleMin = 1.60;
											this.autoScale = false;
											dataSource[6].name = data.Name;
											dataSource[6].series.push({name: name, value: value});
										}
										break;
									case "打ち出し角 上下":// "度"
										if (this.name === "打ち出し角 上下") {
											this.autoScale = true;
											dataSource[7].name = data.Name;
											dataSource[7].series.push({name: name, value: value});
										}
										break;
									case "打ち出し角 左右":// "度"
										if (this.name === "打ち出し角 左右") {
											this.autoScale = true;
											dataSource[8].name = data.Name;
											dataSource[8].series.push({name: name, value: value});
										}
										break;
									case "バックスピン":// "rpm"
										if (this.name === "バックスピン") {
											this.autoScale = true;
											dataSource[9].name = data.Name;
											dataSource[9].series.push({name: name, value: value});
										}
										break;
									case  "サイドスピン":// "rpm"
										if (this.name === "サイドスピン") {
											dataSource[10].name = data.Name;
											dataSource[10].series.push({name: name, value: value});
										}
										break;
									case  "ブロー角":// "度"
										if (this.name === "ブロー角") {
											dataSource[11].name = data.Name;
											dataSource[11].series.push({name: name, value: value});
										}
										break;
									case  "ヘッド軌道": // "度"
										if (this.name === "ヘッド軌道") {
											dataSource[12].name = data.Name;
											dataSource[12].series.push({name: name, value: value});
										}
										break;
									case  "フェイス角":// "度"
										if (this.name === "フェイス角") {
											dataSource[13].name = data.Name;
											dataSource[13].series.push({name: name, value: value});
										}
										break;
									default:
								}
							}
						);
					}
				});

				this.dataSource = dataSource;
			} else {
				// Todo: error code messege
			}
		} finally {
			this.Progress(false);
		}
	}

	/**
	 * @returns none
	 */
	public Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

}
